export const configTranslations = {
    'category.slider.home.web': 'Slider página de inicio web',
    'category.recomended.items.home.web': 'Ítems recomendados página de inicio web',
    'category.banner.home.web': 'Banner slider página de inicio',
}